// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block-title[data-v-7bc6c10c]{height:22px;margin-bottom:24px}.block-title__text[data-v-7bc6c10c]{color:var(--text-text-high,#fff);font-family:Anton,Anton-Fallback,Impact;font-size:22px;font-style:normal;font-weight:400;line-height:22px;letter-spacing:.44px;margin:0}", ""]);
// Exports
module.exports = exports;
